import LumiReport from "@/components/lumi-report";

export function AiInsightsTab() {
  return (
    <div className="space-y-4">
      <LumiReport />
    </div>
  );
}

export default AiInsightsTab;
